import { FunctionComponent, useEffect, useState } from 'react';
import type { ButtonProps } from '@mui/material';
import { LoadingButton } from '../components/LoadingButton';
import { NoInternetIcon } from '../Images/NoInternetIcon';

interface NextButtonProps extends Partial<ButtonProps> {
  isLoading?: boolean;
  disabled?: boolean;
  style?: React.CSSProperties;
  className?: string;
  children?: React.ReactNode;
  loading?: boolean;
}

export const NextButton: FunctionComponent<NextButtonProps> = ({ isLoading = false, ...rest }) => {
  const [online, setOnline] = useState(navigator.onLine);

  useEffect(() => {
    function handleOnline() {
      setOnline(true);
    }

    function handleOffline() {
      setOnline(false);
    }

    globalThis.addEventListener('online', handleOnline);
    globalThis.addEventListener('offline', handleOffline);

    return () => {
      globalThis.removeEventListener('online', handleOnline);
      globalThis.removeEventListener('offline', handleOffline);
    };
  }, []);

  return (
    <LoadingButton
      {...rest}
      disabled={rest.disabled || !online}
      style={rest.style ? { ...rest.style, display: 'flex' } : { display: 'flex' }}
      type="button"
      className={`${rest.className ?? ''} next-button`}
    >
      {rest.children}
      {!online && (
        <div style={{ margin: 'auto', marginLeft: '.5rem', display: 'flex' }}>
          <NoInternetIcon />
        </div>
      )}
    </LoadingButton>
  );
};
